import { useEffect, useState } from 'react';

export const useWebview = () => {
  const [isWebview, setIsWebview] = useState(false);

  // Check if the "webview" cookie is present to determine if header and footer should be hidden
  useEffect(() => {
    const webCookies = document.cookie.split(';').map((cookie) => cookie.trim());
    const webviewCookie = webCookies.find((cookie) => cookie.startsWith('webview='));
    if (webviewCookie) {
      setIsWebview(true);
    }
  }, []);

  return isWebview;
};
